export const planningCenterKeys = {
  all: () => ['planning-center'] as const,
  status: () => [...planningCenterKeys.all(), 'status'] as const,
  preview: () => [...planningCenterKeys.all(), 'preview'] as const,
  imports: () => [...planningCenterKeys.all(), 'imports'] as const,
  detail: (id: string) => [...planningCenterKeys.all(), 'import', id] as const,
  issues: (id: string, severity: string) =>
    [...planningCenterKeys.all(), 'import', id, 'issues', severity] as const,
}
